function TaskIcon({
  type = 'regular',
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  type?: 'bold' | 'regular';
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <>
      {type === 'regular' && (
        <span className={className} onClick={onClick}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width={size}
            height={size}
            viewBox='0 0 32 32'
            fill='currentColor'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M4.44446 24.8898C4.44446 26.8534 6.03633 28.4453 8.00001 28.4453L24 28.4453C25.9637 28.4453 27.5556 26.8534 27.5556 24.8898L27.5556 17.3342C27.5556 16.8433 27.1576 16.4453 26.6667 16.4453C26.1758 16.4453 25.7778 16.8433 25.7778 17.3342L25.7778 24.8898C25.7778 25.8716 24.9819 26.6675 24 26.6675L8.00001 26.6675C7.01817 26.6675 6.22224 25.8716 6.22224 24.8898L6.22223 8.88976C6.22223 7.90792 7.01817 7.11198 8.00001 7.11198L14.6667 7.11198C15.1576 7.11198 15.5556 6.71401 15.5556 6.22309C15.5556 5.73217 15.1576 5.3342 14.6667 5.3342L8.00001 5.3342C6.03633 5.3342 4.44446 6.92608 4.44446 8.88976L4.44446 24.8898Z'
            />
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M28.2534 7.28377C28.649 7.66919 28.6572 8.3023 28.2718 8.69787L17.0125 20.2534C16.824 20.4469 16.5652 20.5559 16.2951 20.5556C16.0249 20.5552 15.7664 20.4456 15.5784 20.2517L10.8376 15.3628C10.4532 14.9663 10.4629 14.3332 10.8594 13.9488C11.2559 13.5643 11.889 13.574 12.2734 13.9705L16.298 18.1208L26.8393 7.30214C27.2247 6.90657 27.8578 6.89835 28.2534 7.28377Z'
            />
          </svg>
        </span>
      )}
      {type === 'bold' && (
        <span className={className} onClick={onClick}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width={size}
            height={size}
            viewBox='0 0 16 16'
            fill='currentColor'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M15.1382 2.19526C15.3986 2.45561 15.3986 2.87772 15.1382 3.13807L8.47157 9.80474C8.21122 10.0651 7.78911 10.0651 7.52876 9.80474L5.52876 7.80474C5.26841 7.54439 5.26841 7.12228 5.52876 6.86193C5.78911 6.60158 6.21122 6.60158 6.47157 6.86193L8.00016 8.39052L14.1954 2.19526C14.4558 1.93491 14.8779 1.93491 15.1382 2.19526Z'
            />
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M3.3335 2.66683C3.15668 2.66683 2.98712 2.73707 2.86209 2.86209C2.73707 2.98712 2.66683 3.15668 2.66683 3.3335V12.6668C2.66683 12.8436 2.73707 13.0132 2.86209 13.1382C2.98712 13.2633 3.15669 13.3335 3.3335 13.3335H12.6668C12.8436 13.3335 13.0132 13.2633 13.1382 13.1382C13.2633 13.0132 13.3335 12.8436 13.3335 12.6668V8.00016C13.3335 7.63197 13.632 7.3335 14.0002 7.3335C14.3684 7.3335 14.6668 7.63197 14.6668 8.00016V12.6668C14.6668 13.1973 14.4561 13.706 14.081 14.081C13.706 14.4561 13.1973 14.6668 12.6668 14.6668H3.3335C2.80306 14.6668 2.29436 14.4561 1.91928 14.081C1.54421 13.706 1.3335 13.1973 1.3335 12.6668V3.3335C1.3335 2.80306 1.54421 2.29436 1.91928 1.91928C2.29436 1.54421 2.80306 1.3335 3.3335 1.3335H10.6668C11.035 1.3335 11.3335 1.63197 11.3335 2.00016C11.3335 2.36835 11.035 2.66683 10.6668 2.66683H3.3335Z'
            />
          </svg>
        </span>
      )}
    </>
  );
}

export default TaskIcon;
